import { useEffect, useState } from 'react';
import { readCookie } from '@wbk/utils';
import LoginButton from '@/components/buttons/LoginButton';
import UserMenu from './UserMenu';

const UserProfileButton = () => {
  const [hasCookie, setHasCookie] = useState(false);

  useEffect(() => {
    const token = readCookie('token');
    if (token) {
      setHasCookie(true);
    }
  }, []);

  return hasCookie ? <UserMenu /> : <LoginButton />;
};

export default UserProfileButton;
